import { render, staticRenderFns } from "./CardFranquia.vue?vue&type=template&id=24fee4aa&scoped=true"
import script from "./CardFranquia.vue?vue&type=script&lang=js"
export * from "./CardFranquia.vue?vue&type=script&lang=js"
import style0 from "./CardFranquia.vue?vue&type=style&index=0&id=24fee4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fee4aa",
  null
  
)

export default component.exports